export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    gif: false,
    deviation: false,
    deviationThumb: false,
    allowUploads: false,
    daVideo: false,
    gallery: false,
    anchor: true,
    spinner: false,
    blockDragging: true,
    blockquote: true,
    heading: true,
    hashtag: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: false,
    textFont: false,
    textHighlight: false,
    history: true,
    indent: {
        captureTab: true
    },
    muro: false,
    characterCount: false
};

//# sourceMappingURL=config.js.map